import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "cluster-wizard" }
const _hoisted_2 = { class: "cluster-wizard__sidebar" }
const _hoisted_3 = { class: "cluster-wizard__section" }
const _hoisted_4 = { class: "heading-xl" }
const _hoisted_5 = { class: "cluster-wizard__group" }
const _hoisted_6 = {
  key: 0,
  class: "cluster-wizard__section"
}
const _hoisted_7 = { class: "heading-xl" }
const _hoisted_8 = {
  key: 1,
  class: "cluster-wizard__section"
}
const _hoisted_9 = { class: "heading-xl" }
const _hoisted_10 = { class: "cluster-wizard__tiles" }
const _hoisted_11 = {
  key: 2,
  class: "cluster-wizard__section"
}
const _hoisted_12 = { class: "label-xs cluster-wizard__help-text" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "cluster-wizard__help-image" }, null, -1)
const _hoisted_14 = { class: "cluster-wizard__content" }
const _hoisted_15 = {
  key: 0,
  class: "cluster-wizard__section"
}
const _hoisted_16 = { class: "heading-xl cluster-wizard__line-header" }
const _hoisted_17 = { class: "cluster-wizard__line" }
const _hoisted_18 = {
  key: 1,
  class: "cluster-wizard__section"
}
const _hoisted_19 = { class: "heading-xl cluster-wizard__line-header" }
const _hoisted_20 = { class: "cluster-wizard__line" }
const _hoisted_21 = {
  key: 2,
  class: "cluster-wizard__section"
}
const _hoisted_22 = { class: "heading-xl cluster-wizard__line-header" }
const _hoisted_23 = { class: "cluster-wizard__line" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "cluster-wizard__cluster-pad" }, null, -1)
const _hoisted_25 = {
  key: 3,
  class: "cluster-wizard__fallback"
}
const _hoisted_26 = { class: "cluster-wizard__fallback-content" }
const _hoisted_27 = { class: "heading-m" }
const _hoisted_28 = { class: "paragraph-m" }
const _hoisted_29 = { class: "cluster-wizard__footer" }
const _hoisted_30 = { class: "cluster-wizard__form" }
const _hoisted_31 = { class: "cluster-wizard__save" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CaseClusterItem = _resolveComponent("CaseClusterItem")!
  const _component_CaseClusterItemRow = _resolveComponent("CaseClusterItemRow")!
  const _component_CardItemSmall = _resolveComponent("CardItemSmall")!
  const _component_CardItemTile = _resolveComponent("CardItemTile")!
  const _component_ClusterWizardItem = _resolveComponent("ClusterWizardItem")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NModalWindow = _resolveComponent("NModalWindow")!
  const _component_CaseClusterForm = _resolveComponent("CaseClusterForm")!
  const _directive_scroll_horizontally = _resolveDirective("scroll-horizontally")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NModalWindow, {
      layout: true,
      "has-margins": false,
      customSize: "90vw",
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
      className: "cluster-wizard__modal"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.itemTitleText), 1),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainClusterAndSelectedClusters, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "cluster-wizard__group-item",
                    key: item.id
                  }, [
                    (_ctx.mainClusterAndSelectedClusters.length === 1)
                      ? (_openBlock(), _createBlock(_component_CaseClusterItem, {
                          key: 0,
                          item: item,
                          objects: "faces",
                          onAction: () => _ctx.clusterItemAction(item.id),
                          showRole: true,
                          canAcknowledge: false
                        }, null, 8, ["item", "onAction"]))
                      : (_openBlock(), _createBlock(_component_CaseClusterItemRow, {
                          key: 1,
                          item: item,
                          canClose: item.id !== _ctx.caseCluster.id,
                          onAction: (v) => _ctx.actionHandler(`cluster_${v}`, item)
                        }, null, 8, ["item", "canClose", "onAction"]))
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.relatedHumanCards.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('cases.card_index')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedHumanCards, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "cluster-wizard__row-item",
                      key: item.id
                    }, [
                      _createVNode(_component_CardItemSmall, {
                        type: "humans",
                        item: item,
                        "show-actions": false,
                        canClose: "",
                        onAction: (v) => _ctx.actionHandler(`card_${v}`, item)
                      }, null, 8, ["item", "onAction"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.relatedCaseClusters.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('cases.participants_and_clusters')), 1),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedCaseClusters, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id
                      }, [
                        _createVNode(_component_CaseClusterItemRow, {
                          item: item,
                          canClose: true,
                          onAction: (v) => _ctx.actionHandler(`related_case_cluster_${v}`, item)
                        }, null, 8, ["item", "onAction"])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.relatedCaseClusters.length && !_ctx.relatedHumanCards.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('cases.wizard_help_text')), 1),
                  _hoisted_13
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.allHumanCards.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('cases.card_index')), 1),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allHumanCards, (item) => {
                      return (_openBlock(), _createBlock(_component_ClusterWizardItem, {
                        key: item.id,
                        confidence: item.looks_like_confidence,
                        disabled: !_ctx.modelAcl.update,
                        onAction: (v) => _ctx.actionHandler(`card_${v}`, item)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CardItemTile, {
                            type: "humans",
                            item: item
                          }, null, 8, ["item"])
                        ]),
                        _: 2
                      }, 1032, ["confidence", "disabled", "onAction"]))
                    }), 128))
                  ])), [
                    [_directive_scroll_horizontally]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.allCaseClusters.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('cases.clusters_in_other_cases')), 1),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCaseClusters, (item) => {
                      return (_openBlock(), _createBlock(_component_ClusterWizardItem, {
                        key: item.id,
                        confidence: item.looks_like_confidence,
                        caseId: item.case,
                        disabled: !_ctx.modelAcl.update,
                        onAction: (v) => _ctx.actionHandler(`related_case_cluster_${v}`, item)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CaseClusterItem, {
                            showCase: "",
                            hideCaseDate: "",
                            item: item,
                            canAcknowledge: false,
                            onAction: () => _ctx.clusterItemAction(item.id)
                          }, null, 8, ["item", "onAction"])
                        ]),
                        _: 2
                      }, 1032, ["confidence", "caseId", "disabled", "onAction"]))
                    }), 128))
                  ])), [
                    [_directive_scroll_horizontally]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentCaseClusters.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('cases.clusters_in_current_case')), 1),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentCaseClusters, (item) => {
                      return (_openBlock(), _createBlock(_component_ClusterWizardItem, {
                        key: item.id,
                        confidence: item.looks_like_confidence,
                        disabled: !_ctx.modelAcl.update,
                        onAction: (v) => _ctx.actionHandler(`cluster_${v}`, item)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CaseClusterItem, {
                            item: item,
                            canAcknowledge: false,
                            "show-top-confidence": true,
                            onAction: () => _ctx.clusterItemAction(item.id)
                          }, null, 8, ["item", "onAction"]),
                          _hoisted_24
                        ]),
                        _: 2
                      }, 1032, ["confidence", "disabled", "onAction"]))
                    }), 128))
                  ])), [
                    [_directive_scroll_horizontally]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showFallback)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('cases.fallback_title')), 1),
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('cases.fallback_description')), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          (_ctx.caseCluster.role)
            ? (_openBlock(), _createBlock(_component_NButton, {
                key: 0,
                type: "primary",
                onClick: _cache[0] || (_cache[0] = () => _ctx.saveHandler(false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(!_ctx.modelAcl.update ? 'cases.close' : 'cases.save_and_done', 'f')), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.modelAcl.update && !_ctx.hasCaseError)
                  ? (_openBlock(), _createBlock(_component_NButton, {
                      key: 0,
                      type: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCreateForm = true)),
                      icon: "participant-create"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.saveButtonText), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_NButton, {
                  type: "secondary",
                  onClick: _cache[2] || (_cache[2] = () => _ctx.saveHandler(false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(!_ctx.modelAcl.update ? 'cases.close' : 'cases.save_and_done', 'f')), 1)
                  ]),
                  _: 1
                })
              ], 64))
        ])
      ]),
      _: 1
    }),
    (_ctx.showCreateForm)
      ? (_openBlock(), _createBlock(_component_NModalWindow, {
          key: 0,
          layout: "true",
          label: _ctx.saveButtonText,
          customSize: "570px",
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCreateForm = false))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_CaseClusterForm, {
                ref: "form",
                item: _ctx.caseCluster,
                disabled: !_ctx.modelAcl.update
              }, null, 8, ["item", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_NButton, {
                type: "primary",
                onClick: _cache[4] || (_cache[4] = () => _ctx.saveHandler(true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(!_ctx.modelAcl.update ? 'cases.close' : 'cases.save_and_done', 'f')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["label"]))
      : _createCommentVNode("", true)
  ], 64))
}